import { FunctionComponent, memo } from "react";
import { IProps } from "./phrase-triggers-interactions-tagged-filters.types";
import { Form, Formik } from "formik";
import { SubmitOnChange } from "@edgetier/components";
import Toggle from "components-for/filters/toggle";
import { DateFilter } from "@edgetier/date-filter";
import { trackUser } from "utilities/track-user";
import "./phrase-triggers-interactions-tagged-filters.scss";

/**
 * Tag report filters, display options on the phrase trigger chart.
 * @param props.initialValues       Initial form filter values
 * @param props.onChange            Submit function triggered on change
 */
const PhraseTriggersInteractionsTaggedFilters: FunctionComponent<IProps> = ({ initialValues, onChange }) => (
    <Formik initialValues={initialValues} onSubmit={onChange}>
        <Form
            name="phrase-triggers-interactions-tagged-filters"
            className="phrase-triggers-interactions-tagged-filters"
        >
            <DateFilter
                allowTimeSelect
                showResetButton={false}
                startDateName="startDateTime"
                endDateName="endDateTime"
                onChange={() => {
                    trackUser("Select Data Range");
                }}
                limitSelectionMonths={1}
            />
            <div className="proportion-toggle">
                <Toggle
                    name="dayTriggerView"
                    leftLabel="Per Day"
                    rightLabel="Per Trigger"
                    onChange={(checked) => {
                        if (checked) {
                            trackUser("Change Per Trigger View");
                        } else {
                            trackUser("Change Per Day View");
                        }
                    }}
                />
            </div>

            <SubmitOnChange />
        </Form>
    </Formik>
);

export default memo(PhraseTriggersInteractionsTaggedFilters);
